import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, Events } from 'ionic-angular';
import { TabsPage } from '../tabs/tabs';
import { Tabs2Page } from '../tabs2/tabs2';

/**
 * Generated class for the ExitoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-exito',
  templateUrl: 'exito.html',
})
export class ExitoPage {
  pedido: any = ''
  info: any = ''
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public viewCtrl : ViewController,
    public events: Events
    ) {
      this.pedido = this.navParams.get('pedido')
      this.info = this.navParams.get('info')
  }

  transform(value) {
    if(value){
      let val
      val = parseFloat(value)
      val = parseFloat(val).toFixed(2)
      val = val.toString().split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }

  inicio() {
    if (window.localStorage.getItem('super')) {
      this.navCtrl.setRoot(TabsPage, {value: 'Dashboard'})
    } else {
      this.navCtrl.setRoot(Tabs2Page, {value: 'Dashboard'})
    }
  }

  close(view=null){
    this.events.publish('close:exito',view)
    this.viewCtrl.dismiss()
    // if (view === "pedidos") {
    //   this.navCtrl.setRoot(PedidosPage)
    // } else {
    //   this.navCtrl.setRoot(DashboardPage)
    // }
  }

}



// WEBPACK FOOTER //
// ./src/pages/exito/exito.ts